module.exports = window.PlatformPhoenix_BreezeUIReact